/**
 * Link component
 *
 * Basically a wrapper around react router dom link
 *
 * Optional props:
 * white : boolean - white text
 * underline : boolean - add underline to link
 *
 * Examples of component:
 * <Link to={{ pathname='/' }}>Standard link</Link>
 * <Link white to={{ pathname='/' }}>white link</Link>
 *
 */

import React from 'react';
import styled from 'styled-components';
import { Link as RouterLink } from 'react-router-dom';
import { colors } from '../../variables';

const getColor = (props, state) => {
	if (props.white) {
		if (state === 'hover') return colors.grey.light;
		return '#fff';
	}

	if (props.digital) {
		if (state === 'hover') return colors.blue.digitalLight;
		return colors.blue.digitalDark;
	}

	if (state === 'hover') return colors.blue.brommaDark;
	return colors.blue.bromma;
};

const getDisplay = props => {
	if (props.block) return 'block';
	if (props.inlineBlock) return 'inline-block';
	return 'inline';
};
const getLineHeight = props => {
	if (props.height) return props.height;
	return 'normal';
};

const StyledLink = ({ white, digital, underline, inlineBlock, ...rest }) => (
	<RouterLink {...rest} />
);

const Link = styled(StyledLink)`
	cursor: pointer;
	color: ${props => getColor(props)};
	text-decoration: ${props => (props.underline ? 'underline' : 'none')};
	display: ${props => getDisplay(props)};
	line-height: ${props => getLineHeight(props)};

	&:hover,
	&:focus {
		color: ${props => getColor(props, 'hover')};
	}
`;

export default Link;



// WEBPACK FOOTER //
// ./src/components/Common/Link/Link.js